import actionTypes from '../constants/action-types';

const setSiteId = (site) => ({
  type: actionTypes.SET_SITE_ID,
  payload: {
    site,
  },
});

export default setSiteId;
